// PregnancyEducationalContent.js
import React from "react";
function PregnancyEducationalContent() {
  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <strong>Apa itu Kalkulator Kehamilan dan Bagaimana Cara Kerjanya?</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Kalkulator Kehamilan</strong> adalah alat medis elektronik yang membantu ibu hamil menentukan
                tanggal perkiraan lahir dan menghitung usia kehamilan dengan akurat. Kalkulator ini didasarkan pada rumus medis
                yang terpercaya seperti <strong>Aturan Naegele</strong> yang digunakan oleh dokter di seluruh dunia.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Bagaimana Cara Kerja Kalkulator Kehamilan?
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                Kalkulator kehamilan bekerja melalui langkah-langkah berikut:
              </p>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Memasukkan tanggal haid terakhir:</strong> Ini adalah tanggal di mana seorang wanita memulai
                  haid terakhir sebelum kehamilan terjadi.
                </li>
                <li>
                  <strong>Menentukan panjang siklus:</strong> Rata-rata normal 28 hari, tetapi bervariasi dari satu wanita
                  ke wanita lain (20-45 hari).
                </li>
                <li>
                  <strong>Menghitung tanggal pembuahan:</strong> Biasanya terjadi di tengah siklus (hari ke-14 sebelum
                  haid berikutnya).
                </li>
                <li>
                  <strong>Menambahkan 280 hari:</strong> Ini adalah durasi kehamilan normal (40 minggu) dari
                  hari pertama haid terakhir.
                </li>
              </ol>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 Aturan Medis Naegele:</strong>
                <br />
                Untuk menghitung tanggal perkiraan lahir:
                <br />
                • Kurangi 3 bulan dari tanggal haid terakhir
                <br />
                • Tambahkan 7 hari
                <br />
                • Tambahkan 1 tahun
                <br/>                <strong>Contoh:</strong> Haid terakhir pada 10 Januari 2024
                <br />
                Perhitungan: 10 Januari - 3 bulan + 7 hari = <strong>17 Oktober 2024</strong>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Mengapa Kita Menghitung dari Haid Terakhir dan Bukan dari Hari Pembuahan?
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                Alasan medisnya adalah bahwa kebanyakan wanita mengingat dengan tepat tanggal haid terakhir, sementara sulit
                menentukan hari pembuahan dengan pasti. Oleh karena itu, dokter sepakat untuk menggunakan hari pertama haid terakhir sebagai titik
                awal yang seragam untuk menghitung kehamilan.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Tahap Kehamilan Secara Detail - Minggu dan Bulan</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineWidth: "1.8" }}>
                <strong>Kehamilan</strong> dibagi menjadi tiga tahap utama yang disebut trimester,
                setiap tahap memiliki karakteristik dan perkembangannya sendiri:
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Trimester Pertama Kehamilan (Minggu 1 - 13)
              </h3>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>Bulan:</strong> Bulan 1, 2, 3
                <br />
                <strong>Durasi:</strong> Dari minggu 1 hingga akhir minggu 13
                <br/>                <strong>Perkembangan Janin:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Minggu 4-5: Muncul kantung kehamilan dan detak jantung pada USG</li>
                  <li>Minggu 6-8: Pembentukan organ dasar (jantung, otak, ginjal)</li>
                  <li>Minggu 9-12: Sebagian besar organ lengkap, mulai bergerak</li>
                  <li>Minggu 13: Panjang janin sekitar 7.5 cm, berat 25 gram</li>
                </ul>
                <br />
                <strong>Gejala Umum:</strong>
                <ul>
                  <li>Mual di pagi hari dan muntah</li>
                  <li>Kelelahan dan kelelahan ekstrem</li>
                  <li>Perubahan pada payudara (nyeri dan pembesaran)</li>
                  <li>Perubahan suasana hati</li>
                  <li>Sering buang air kecil</li>
                </ul>
                <br />
                <strong>Pemeriksaan Penting:</strong>
                <ul>
                  <li>Tes kehamilan digital (HCG)</li>
                  <li>USG transvaginal (minggu 6-8)</li>
                  <li>Tes darah lengkap</li>
                  <li>Tes hormon tiroid</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Trimester Kedua Kehamilan (Minggu 14 - 27)
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>Bulan:</strong> Bulan 4, 5, 6
                <br />
                <strong>Durasi:</strong> Dari minggu 14 hingga akhir minggu 27
                <br/>                <strong>Perkembangan Janin:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Minggu 14-16: Jenis kelamin janin dapat diketahui dengan USG</li>
                  <li>Minggu 18-20: Ibu mulai merasakan gerakan janin</li>
                  <li>Minggu 22-24: Perkembangan paru-paru, janin mendengar suara</li>
                  <li>Minggu 27: Panjang janin sekitar 36 cm, berat 875 gram</li>
                </ul>
                <br />
                <strong>Gejala Umum:</strong>
                <ul>
                  <li>Penurunan mual dan kelelahan</li>
                  <li>Peningkatan energi dan aktivitas</li>
                  <li>Perut mulai terlihat jelas</li>
                  <li>Nyeri punggung dan panggul</li>
                  <li>Maag</li>
                </ul>
                <br />
                <strong>Pemeriksaan Penting:</strong>
                <ul>
                  <li>USG detail (minggu 18-22)</li>
                  <li>Tes diabetes gestasional (minggu 24-28)</li>
                  <li>Pemeriksaan kelainan janin</li>
                  <li>Pemantauan tekanan darah secara teratur</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Trimester Ketiga Kehamilan (Minggu 28 - 40)
              </h3>
              <div className="alert alert-warning" style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}>
                <strong>Bulan:</strong> Bulan 7, 8, 9
                <br />
                <strong>Durasi:</strong> Dari minggu 28 hingga kelahiran (minggu 37-42)
                <br/>                <strong>Perkembangan Janin:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Minggu 28-32: Pertumbuhan otak cepat, membuka dan menutup mata</li>
                  <li>Minggu 33-36: Perkembangan paru-paru lengkap</li>
                  <li>Minggu 37-40: Janin tumbuh sempurna dan siap lahir</li>
                  <li>Minggu 40: Panjang janin sekitar 50 cm, berat 3.2-3.6 kg</li>
                </ul>
                <br />
                <strong>Gejala Umum:</strong>
                <ul>
                  <li>Kesulitan bernapas karena tekanan janin</li>
                  <li>Pembengkakan kaki dan tangan</li>
                  <li>Kontraksi Braxton Hicks (kontraksi palsu)</li>
                  <li>Sering buang air kecil di malam hari</li>
                  <li>Kesulitan tidur</li>
                </ul>
                <br />
                <strong>Pemeriksaan Penting:</strong>
                <ul>
                  <li>Pemantauan rutin setiap 2 minggu kemudian setiap minggu</li>
                  <li>Pemeriksaan posisi janin dengan USG</li>
                  <li>Pemantauan detak jantung janin (CTG)</li>
                  <li>Pemeriksaan Streptococcus grup B</li>
                </ul>
              </div>
              <div className="alert alert-danger mt-3" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                <strong>⚠️ Kapan Harus ke Rumah Sakit?</strong>
                <ul>
                  <li>Kontraksi teratur setiap 5-10 menit</li>
                  <li>Pecah ketuban (cairan ketuban keluar)</li>
                  <li>Pendarahan vagina</li>
                  <li>Penurunan gerakan janin yang signifikan</li>
                  <li>Nyeri hebat dan terus-menerus di perut</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Perhitungan Kehamilan dalam Minggu vs Bulan</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Ada dua cara umum untuk menghitung usia kehamilan, masing-masing memiliki manfaatnya:
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Perhitungan Kehamilan dalam Minggu (Metode Medis)
              </h3>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>Durasi Total:</strong> 40 minggu (280 hari)
                <br/>                <strong>Keunggulan:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>Lebih akurat:</strong> Dokter menggunakannya untuk memantau pertumbuhan janin dengan akurat</li>
                  <li><strong>Standar spesifik:</strong> Setiap minggu memiliki standar medis yang jelas</li>
                  <li><strong>Pemeriksaan:</strong> Jadwal pemeriksaan ditentukan dalam minggu</li>
                  <li><strong>Universal:</strong> Sistem yang sama di semua negara di dunia</li>
                </ul>
                <br />
                <strong>Cara Menghitung:</strong>
                <br />
                Hitung jumlah hari dari hari pertama haid terakhir hingga hari ini, lalu bagi dengan 7.
                <br />
                <strong>Contoh:</strong> 154 hari telah berlalu ÷ 7 = <strong>22 minggu</strong>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Perhitungan Kehamilan dalam Bulan (Metode Populer)
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}>
                <strong>Durasi Total:</strong> 9 bulan (atau 10 bulan lunar)
                <br/>                <strong>Keunggulan:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>Mudah dipahami:</strong> Lebih mudah diingat dan dibicarakan dengan orang lain</li>
                  <li><strong>Tradisional:</strong> Cara yang biasa digunakan di masyarakat</li>
                  <li><strong>Tahap jelas:</strong> Tiga trimester × tiga bulan</li>
                </ul>
                <br />
                <strong>Cara Menghitung:</strong>
                <br />
                Setiap 4 minggu kira-kira = 1 bulan
                <br />
                <strong>Contoh:</strong> 22 minggu ÷ 4 = <strong>5.5 bulan</strong> (pertengahan bulan keenam)
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                Tabel Konversi Minggu ke Bulan
              </h3>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr style={{ backgroundColor: "#e7f3fe" }}>
                    <th style={{ textAlign: "center", padding: "12px" }}>Bulan</th>
                    <th style={{ textAlign: "center", padding: "12px" }}>Minggu</th>
                    <th style={{ textAlign: "center", padding: "12px" }}>Tahap</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Pertama</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>1 - 4</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Pertama</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Kedua</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>5 - 8</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Pertama</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Ketiga</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>9 - 13</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Pertama</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Keempat</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>14 - 17</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Kedua</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Kelima</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>18 - 22</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Kedua</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Keenam</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>23 - 27</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Kedua</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Ketujuh</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>28 - 31</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Ketiga</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Kedelapan</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>32 - 35</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Ketiga</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>Bulan Kesembilan</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>36 - 40</td>
                    <td style={{ textAlign: "center", padding: "10px" }}>Trimester Ketiga</td>
                  </tr>
                </tbody>
              </table>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 Tips:</strong> Gunakan minggu untuk pemantauan medis dan bulan untuk
                berbicara dengan keluarga dan teman. Keduanya benar!
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>Tips Penting Selama Masa Kehamilan</strong>
            </div>
            <div className="info-section-body">
              <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                Nutrisi yang Tepat untuk Ibu Hamil:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Asam Folat:</strong> 400-800 mikrogram per hari untuk mencegah cacat
                </li>
                <li>
                  <strong>Kalsium:</strong> 1000 mg per hari untuk kesehatan tulang
                </li>
                <li>
                  <strong>Zat Besi:</strong> 27 mg per hari untuk mencegah anemia
                </li>
                <li>
                  <strong>Protein:</strong> 70-100 gram per hari dari daging dan kacang-kacangan
                </li>
                <li>
                  <strong>Air:</strong> 8-10 gelas per hari untuk hidrasi
                </li>
              </ul>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                Makanan yang Harus Dihindari:
              </h3>
              <div className="alert alert-danger" style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}>
                <ul>
                  <li>Ikan tinggi merkuri (tuna, ikan pedang)</li>
                  <li>Daging dan keju yang tidak dimasak dengan baik</li>
                  <li>Telur mentah atau setengah matang</li>
                  <li>Kafein berlebihan (lebih dari 200 mg per hari)</li>
                  <li>Alkohol sama sekali</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                Aktivitas Fisik dan Olahraga:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>Jalan kaki:</strong> 30 menit setiap hari adalah olahraga terbaik
                </li>
                <li>
                  <strong>Berenang:</strong> Aman dan bermanfaat untuk mengurangi tekanan
                </li>
                <li>
                  <strong>Yoga untuk ibu hamil:</strong> Meningkatkan fleksibilitas dan mengurangi stres
                </li>
                <li>
                  <strong>Latihan Kegel:</strong> Untuk memperkuat otot panggul
                </li>
              </ul>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>⚠️ Hindari:</strong> Olahraga berat, mengangkat beban berat, latihan yang
                memerlukan berbaring telentang setelah bulan keempat.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                Perawatan Kesehatan Mental:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Istirahat dan tidur yang cukup (7-9 jam)</li>
                <li>Praktikkan teknik relaksasi dan meditasi</li>
                <li>Bicarakan perasaan Anda dengan pasangan atau spesialis</li>
                <li>Bergabunglah dengan kelompok dukungan ibu hamil</li>
                <li>Hindari stres dan tekanan psikologis sebisa mungkin</li>
              </ul>
              <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                Pemantauan Medis Rutin:
              </h3>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>Jadwal Kunjungan yang Direkomendasikan:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>Minggu 4-28: Kunjungan setiap 4 minggu</li>
                  <li>Minggu 28-36: Kunjungan setiap 2-3 minggu</li>
                  <li>Minggu 36-40: Kunjungan mingguan</li>
                </ul>
              </div>
              <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                <strong>✓ Tips Emas:</strong> Selalu dengarkan tubuh Anda. Jika Anda merasakan sesuatu yang tidak
                normal, jangan ragu untuk menghubungi dokter Anda kapan pun. Kesehatan Anda dan kesehatan bayi Anda adalah yang terpenting!
              </div>
            </div>
          </div>
        </div>
        <br />
        <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
          Pertanyaan Umum tentang Kalkulator Kehamilan
        </h2>
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana cara menghitung tanggal lahir dengan akurat?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Untuk menghitung <strong>tanggal lahir</strong> dengan akurat, ikuti langkah-langkah berikut:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Pertama: Aturan Naegele (paling umum digunakan)</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>Tentukan tanggal hari pertama haid terakhir</li>
                <li>Kurangi 3 bulan dari tanggal ini</li>
                <li>Tambahkan 7 hari</li>
                <li>Tambahkan 1 tahun</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>Contoh Praktis:</strong>
                <br />
                Haid terakhir: 15 Maret 2024
                <br />
                - 3 bulan = 15 Desember 2023
                <br />
                + 7 hari = 22 Desember 2023
                <br />
                + 1 tahun = <strong>22 Desember 2024</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Kedua: Menambahkan 280 Hari</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Sederhananya, tambahkan 280 hari (40 minggu) ke tanggal hari pertama haid terakhir.
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Ketiga: Kalkulator Kehamilan Elektronik</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Gunakan <strong>Kalkulator Kehamilan</strong> di bagian atas halaman untuk mendapatkan hasil langsung
                dengan informasi tambahan tentang tahap kehamilan.
              </p>
              <div className="alert alert-warning mt-3" style={{ lineHeight: "1.8" }}>
                <strong>⚠️ Catatan:</strong> Tanggal-tanggal ini bersifat perkiraan. Untuk tanggal yang lebih akurat,
                Anda harus mengunjungi dokter dan melakukan USG pada minggu-minggu pertama (6-12 minggu).
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Berapa durasi kehamilan normal?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>Durasi kehamilan normal</strong> bervariasi dari satu wanita ke wanita lain, tetapi ada standar medis
                yang jelas:
              </p>
              <div className="alert alert-success" style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}>
                <strong>Periode Normal Lengkap:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li><strong>Rata-rata:</strong> 40 minggu (280 hari)</li>
                  <li><strong>Rentang normal:</strong> 37 - 42 minggu</li>
                  <li><strong>Optimal:</strong> 39 - 40 minggu</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Klasifikasi Kelahiran Berdasarkan Waktu:</strong>
              </h4>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>Kelahiran Sangat Prematur</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      Sebelum minggu 28
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#f8d7da" }}>
                      Memerlukan perawatan intensif
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>Kelahiran Prematur</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      Minggu 28 - 36
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#fff3cd" }}>
                      Mungkin memerlukan perawatan khusus
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>Kelahiran Tepat Waktu</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      Minggu 37 - 42
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#d4edda" }}>
                      Normal dan aman
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px" }}>
                      <strong>Kelahiran Terlambat</strong>
                    </td>
                    <td style={{ padding: "12px" }}>
                      Setelah minggu 42
                    </td>
                    <td style={{ padding: "12px", backgroundColor: "#fff3cd" }}>
                      Memerlukan pemantauan ketat
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Fakta Penting:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Hanya 5% wanita yang melahirkan tepat pada tanggal yang ditentukan</li>
                <li>60% melahirkan dalam minggu dari tanggal yang diharapkan</li>
                <li>90% melahirkan dalam dua minggu dari tanggal yang diharapkan</li>
                <li>Kehamilan pertama biasanya berlangsung lebih lama dari kehamilan kedua</li>
              </ul>
              <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                <strong>💡 Informasi Medis:</strong> Janin dianggap tumbuh sempurna setelah menyelesaikan 37 minggu,
                tetapi tetap berada di dalam rahim hingga 39-40 minggu memberikan manfaat tambahan untuk pertumbuhan otak dan paru-paru.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                Bagaimana saya tahu minggu kehamilan saya saat ini?
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                Untuk mengetahui <strong>minggu kehamilan saat ini</strong>, ada beberapa cara akurat:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Pertama: Perhitungan Manual</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>Tentukan tanggal hari pertama haid terakhir</li>
                <li>Hitung jumlah hari dari tanggal tersebut hingga hari ini</li>
                <li>Bagi hasilnya dengan 7 (jumlah hari dalam seminggu)</li>
                <li>Hasilnya adalah jumlah minggu, sisanya adalah jumlah hari tambahan</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>Contoh:</strong>
                <br />
                Haid terakhir: 1 November 2024
                <br />
                Hari ini: 17 Januari 2025
                <br />
                Jumlah hari: 77 hari
                <br />
                77 ÷ 7 = 11 minggu ditambah 2 hari
                <br />
                <strong>Hasil: Anda berada di minggu 11 + 2</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Kedua: Kalkulator Kehamilan Elektronik</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Gunakan <strong>Kalkulator Kehamilan</strong> di bagian atas halaman. Cukup masukkan tanggal
                haid terakhir, dan Anda akan langsung mendapatkan:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>Usia kehamilan dalam minggu dan hari</li>
                <li>Usia kehamilan dalam bulan</li>
                <li>Tahap saat ini (trimester pertama, kedua, ketiga)</li>
                <li>Tanggal perkiraan lahir</li>
                <li>Sisa waktu hingga kelahiran</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>Cara Ketiga: Pemeriksaan USG (Paling Akurat)</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                Pemeriksaan USG pada minggu-minggu pertama (6-12 minggu) adalah cara paling akurat untuk menentukan usia kehamilan,
                di mana dokter mengukur:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li><strong>CRL:</strong> Panjang janin dari kepala hingga bokong (pada trimester pertama)</li>
                <li><strong>BPD:</strong> Diameter kepala janin (pada trimester kedua dan ketiga)</li>
                <li><strong>FL:</strong> Panjang tulang paha</li>
                <li><strong>AC:</strong> Lingkar perut</li>
              </ul>
              <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                <strong>✓ Tips:</strong> Jika siklus Anda tidak teratur atau Anda tidak mengingat tanggal haid terakhir
                dengan akurat, USG dini adalah cara terbaik untuk menentukan usia kehamilan dengan akurat.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PregnancyEducationalContent;